import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Document } from '@sc/data-access-models';
import { forkJoin, from, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StorageHttpService {
  private readonly uploadImageURL = `/api/file/upload`;
  private readonly uploadImageTimeout = '60000';
  private readonly featuresURL = `/api/feature-list`;

  constructor(private readonly httpClient: HttpClient) {}

  uploadDocuments(documents: Document[]): Observable<Document[]> {
    const observables: Observable<Document>[] = [];
    for (const document of documents) {
      const newDocument = { ...document };

      observables.push(
        from(
          new Promise<Document>((resolve, reject) => {
            if (newDocument.file && !newDocument.name) {
              const bodyFormData = new FormData();
              bodyFormData.append('file', newDocument.file);

              this.httpClient
                .post<{ fileURL: string; fileName: string }>(
                  this.uploadImageURL,
                  bodyFormData,
                  {
                    headers: {
                      requestName: 'storage-call uploadImages',
                      timeout: this.uploadImageTimeout,
                    },
                  }
                )
                .subscribe(
                  (res) => {
                    newDocument.url = res.fileURL;
                    newDocument.name = res.fileName;
                    resolve(newDocument);
                  },
                  (err) => {
                    reject(err);
                  }
                );
            } else {
              resolve(newDocument);
            }
          })
        )
      );
    }
    return observables?.length ? forkJoin(observables) : of([]);
  }

  getFeaturesFiles() {
    return this.httpClient.get(this.featuresURL, {
      headers: { requestName: 'feature-list getFeatureFiles' },
    });
  }
}
